import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Slider from 'rc-slider';
import { findIndex as _findIndex } from 'lodash';

import { entityMetaMapping } from 'js/constants';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import Entity from 'components/Entity';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import FormInput from 'components/forms/FormInput';
import FormLangInput from 'components/forms/FormLangInput';
import FormSwitchery from 'components/forms/FormSwitchery';

import CmsCanvas from 'components/cms/CmsCanvas';

class WhiteLabelMainMenuElementData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    const { menuList } = props;

    this.state = {
      cmsElementEntity: this.getCmsElementEntity(props),
    };

    this.defaultFieldTree = undefined //['menu', menuList, props.index];
    this.entityLoading = false;
  }

  componentDidUpdate = prevProps => {
    const {
      appIntl: { displayIntlForm },
    } = this.props;

    if (displayIntlForm !== prevProps.appIntl.displayIntlForm) {
      this.setState({ cmsElementEntity: this.getCmsElementEntity() });
    }
  };

  ownUpdateEntity = (name, value) => {
      this.updateEntity(name , value,['menu', this.props.menuList, this.props.index]);
    }

  // make sure there is a CMS element for given language
  getCmsElementEntity = (props = null) => {
    const { data, entity, appIntl, menuList } = props || this.props;

    const contentIndex = _findIndex(data.getContent(), ['language', appIntl.displayIntlForm]);
    if (contentIndex > -1) {
      return this.getEntityForCms(data.getContent()[contentIndex], props || this.props);
    }

    if (!this.entityLoading) {
      this.entityLoading = true;

      // create new value and return it
      const newValue = data.getContent().slice();
      const newContent = entity.createValue('content', ['menu', menuList, this.props.index], {
        language: appIntl.displayIntlForm,
      });
      newValue.push(newContent);

      this.updateEntity('content', newValue, ['menu', menuList, this.props.index], () => {
        this.entityLoading = false;
      });

      return this.getEntityForCms(newContent, props || this.props);
    }

    return false;
  };

  getEntityForCms = (data, props = null) => {
    const { meta } = props || this.props;

    const entity = new Entity();
    entity.setData(data);
    entity.setMeta(meta, entityMetaMapping.cmsDescription);

    return entity;
  };

  updateCmsElement = content => {
    const { data, appIntl, menuList } = this.props;
    const contentIndex = _findIndex(data.getContent(), ['language', appIntl.displayIntlForm]);
    this.updateEntity('content', content, ['menu', menuList, this.props.index, 'content', contentIndex.toString()]);
  };

  render() {
    const {
      intl: { messages },
      entity,
      data,
      index,
      disabled,
    } = this.props;
    const { cmsElementEntity } = this.state;

    return (
      <div>
        <Row>
          <Col xs={12} md={4}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p className="form-group-title">Menu element {index + 1}</p>
                <div class="form-group-attached">
                  <FormLangInput
                    label={messages.name}
                    name="name"
                    value={data.getName()}
                    meta={data.getNameMetaInformation()}
                    validation={data.getNameValidationResult()}
                    onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                    disabled={disabled}
                  />
                  <FormLangInput
                    label={messages.link}
                    name="link"
                    value={data.getLink()}
                    meta={data.getLinkMetaInformation()}
                    validation={data.getLinkValidationResult()}
                    onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.icon_class}
                    name="iconClass"
                    value={data.getIconClass()}
                    meta={data.getIconClassMetaInformation()}
                    validation={data.getIconClassValidationResult()}
                    onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.list_element_class}
                    name="listCssClasses"
                    value={data.getListCssClasses()}
                    meta={data.getListCssClassesMetaInformation()}
                    validation={data.getListCssClassesValidationResult()}
                    onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.link_class}
                    name="linkCssClasses"
                    value={data.getLinkCssClasses()}
                    meta={data.getLinkCssClassesMetaInformation()}
                    validation={data.getLinkCssClassesValidationResult()}
                    onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                    disabled={disabled}
                  />
                  <div class="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="onlyWhenLoggedIn"
                      checked={data.getOnlyWhenLoggedIn()}
                      value
                      label={messages.show_only_when_user_logged_id}
                      onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={4}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p className="form-group-title">{messages.hide_on_devices}</p>
                <div class="form-group-attached">
                  <div class="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="hiddenPhone"
                      checked={data.getHiddenPhone()}
                      value
                      label={messages.mobile_phones}
                      onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                      disabled={disabled}
                    />
                  </div>
                  <div class="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="hiddenTablet"
                      checked={data.getHiddenTablet()}
                      value
                      label={messages.tablets}
                      onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                      disabled={disabled}
                    />
                  </div>
                  <div class="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="hiddenDesktop"
                      checked={data.getHiddenDesktop()}
                      value
                      label={messages.desktop_pcs}
                      onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p className="form-group-title">{messages.menu_content}</p>
                <div class="form-group-attached">
                  <div className="form-group form-group-default">
                    <FormSwitchery
                      name="hasContent"
                      checked={data.getHasContent()}
                      value
                      label={messages.show_content_on_mouse_over}
                      onChange={(name, value) => {this.ownUpdateEntity(name, value)}}
                      disabled={disabled}
                    />
                  </div>
                  {data.getHasContent() && (
                    <>
                      <div className="form-group form-group-default">
                        <label>
                          {messages.width} {data.getDropdownWidth() || 100}%
                        </label>
                        <Slider
                          value={data.getDropdownWidth() || 100}
                          min={20}
                          max={100}
                          step={5}
                          onChange={(value) => {this.ownUpdateEntity("dropdownWidth", value)}}
                        />
                      </div>
                    </>
                  )}
                </div>

                {data.getHasContent() && (
                  <>
                    <div class="p-t-15 p-b-15">
                      <IntlFormInlineSelector /> {messages.content}
                    </div>
                    <CmsCanvas
                      editMode={!disabled}
                      entity={cmsElementEntity}
                      changeEntity={cmsEntity => {
                        this.updateCmsElement(cmsEntity.getContent());
                      }}
                      itemId={entity.getId()}
                    />
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
WhiteLabelMainMenuElementData.defaultProps = {
  menuList: 'elements',
};

const mapStateToProps = state => {
  return {
    meta: state.entityMeta,
  };
};

export default connect(mapStateToProps)(WhiteLabelMainMenuElementData);
